import { Search, Sparkles } from 'lucide-react';

export const PromptBar = () => {
  return (
    <div
      className="relative hidden md:block lg:flex-grow max-w-[280px] ml-2 sm:ml-4 md:ml-6 lg:ml-[84px]"
      title="Feature coming soon"
      aria-hidden="true"
    >
      <input
        type="text"
        placeholder="Ask AI what you want to do..."
        disabled
        aria-disabled="true"
        title="Feature coming soon"
        className="w-full px-0 py-1.5 pl-10 pr-20 bg-[#F5F8F9] border border-black/10 rounded-full text-xs focus:outline-none placeholder:text-[#7A7D81] shadow-sm opacity-80"
      />

      <span
        aria-hidden="true"
        className="absolute top-1/2 left-3 -translate-y-1/2 flex items-center text-[#7A7D81]"
      >
        <Search className="w-4 h-4" />
      </span>

      <span
        aria-hidden="true"
        className="absolute ml-4 top-1/2 pt-1 right-4 -translate-y-1/2 flex items-center gap-1.5 pointer-events-none"
      >
        <span className="text-[10px] font-semibold text-[#4B5563] tracking-wide leading-tight">
          BETA
        </span>
        <Sparkles className="w-4 h-4 text-[#4B5563]" />
      </span>
    </div>
  );
};
